export default {
  ProductValid: "product_valid",
};
